// @core/api/endpoints/admin/export_audit_logs.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ExportAuditLogsRequest,
  ExportAuditLogsResponse,
} from '../../../types/admin';

const BASE_PATH = '/admin';

/**
 * Export audit logs to file
 * Generates an export file of audit logs matching the specified query in the requested format. Returns a temporary download URL for the generated file.
 */
export async function ExportAuditLogs(
  data: ExportAuditLogsRequest,
  options?: RequestOptions
): Promise<ExportAuditLogsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/admin/audit-logs/export`;
  const requestOptions = options;
  return client.post<ExportAuditLogsResponse>(requestPath, data, requestOptions);
}
